import { Event } from '../types';

export const getCategoryColor = (category: string) => {
    switch (category.toLowerCase()) {
        case 'tech':
            return {
                badge: 'bg-[#7C4DFF]/20 text-[#7C4DFF] border-[#7C4DFF]/30',
                border: 'hover:border-[#7C4DFF]/30',
                text: 'text-[#7C4DFF]',
                bg: 'bg-[#7C4DFF]/10'
            };
        case 'creative':
            return {
                badge: 'bg-[#FF991C]/20 text-[#FF991C] border-[#FF991C]/30',
                border: 'hover:border-[#FF991C]/30',
                text: 'text-[#FF991C]',
                bg: 'bg-[#FF991C]/10'
            };
        case 'logic':
        case 'logic & math':
            return {
                badge: 'bg-[#311b92]/30 text-[#9575CD] border-[#311b92]/40',
                border: 'hover:border-[#311b92]/40',
                text: 'text-[#9575CD]',
                bg: 'bg-[#311b92]/10'
            };
        case 'science':
            return {
                badge: 'bg-[#22C55E]/20 text-[#22C55E] border-[#22C55E]/30',
                border: 'hover:border-[#22C55E]/30',
                text: 'text-[#22C55E]',
                bg: 'bg-[#22C55E]/10'
            };
        default:
            return {
                badge: 'bg-[#FF991C]/20 text-[#FF991C] border-[#FF991C]/30',
                border: 'hover:border-[#FF991C]/30',
                text: 'text-[#FF991C]',
                bg: 'bg-[#FF991C]/10'
            };
    }
};

export const sortEventsByTime = (events: Event[], day: 'day1' | 'day2' | 'both') => {
    return [...events].sort((a, b) => {
        let timeA = '';
        let timeB = '';

        if (day === 'day1') {
            timeA = a.schedule?.day1?.start || '23:59';
            timeB = b.schedule?.day1?.start || '23:59';
        } else if (day === 'day2') {
            timeA = a.schedule?.day2?.start || '23:59';
            timeB = b.schedule?.day2?.start || '23:59';
        } else {
            // For 'both', prioritize day 1 start time, then day 2 start time
            timeA = a.schedule?.day1?.start || a.schedule?.day2?.start || '23:59';
            timeB = b.schedule?.day1?.start || b.schedule?.day2?.start || '23:59';
        }

        return timeA.localeCompare(timeB);
    });
};
